import React from 'react';
import TabBar from "../../TabBar";

class ReportingTemplateIndex extends React.Component {
  render() {
    return (
      <div>
        <TabBar
          items={[
            { to: '/export/report/template', label: 'Template', },
            { to: '/export/report/header', label: 'Header' },
          ]}
        />
        <br />
        {this.props.children}
      </div>
    );
  }
}

export default ReportingTemplateIndex;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportingTemplateIndex.js